/**
 * 管理后台 API 配置文件
 * 统一管理所有管理后台 API 端点
 */

// 从环境变量获取 API 基础 URL
const API_BASE_URL =
  import.meta.env.VITE_API_URL || 'http://localhost:3001/api';

// 导出服务器基础 URL (用于拼接图片路径)
export const SERVER_URL = API_BASE_URL.replace('/api', '');

// 从环境变量获取前端网站 URL
const FRONTEND_URL =
  import.meta.env.VITE_FRONTEND_URL || 'http://localhost:5173';

// 从环境变量获取管理后台 URL
const ADMIN_URL = import.meta.env.VITE_ADMIN_URL || 'http://localhost:5174';

/**
 * 管理后台 API 端点配置
 */
export const ADMIN_API_ENDPOINTS = {
  // ==========================================
  // Dashboard
  // ==========================================
  DASHBOARD: {
    STATS: `${API_BASE_URL}/admin/dashboard/stats`,
  },

  // ==========================================
  // 产品管理
  // ==========================================
  PRODUCTS: {
    LIST: `${API_BASE_URL}/admin/products`,
    UPLOAD_IMAGE: `${API_BASE_URL}/admin/products/upload-image`,
    BY_ID: (id) => `${API_BASE_URL}/admin/products/${id}`,
  },

  // ==========================================
  // 活动管理
  // ==========================================
  EVENTS: {
    LIST: `${API_BASE_URL}/admin/events`,
    UPLOAD_IMAGE: `${API_BASE_URL}/admin/events/upload-image`,
    BY_ID: (id) => `${API_BASE_URL}/admin/events/${id}`,
  },

  // ==========================================
  // FAQ 管理
  // ==========================================
  FAQS: {
    LIST: `${API_BASE_URL}/admin/faqs`,
    UPLOAD_IMAGE: `${API_BASE_URL}/admin/faqs/upload-image`,
    BY_ID: (id) => `${API_BASE_URL}/admin/faqs/${id}`,
  },

  // ==========================================
  // 零件支持管理
  // ==========================================
  SPARE_PARTS: {
    LIST: `${API_BASE_URL}/admin/spare-parts`,
    UPLOAD_IMAGE: `${API_BASE_URL}/admin/spare-parts/upload-image`,
    BY_ID: (id) => `${API_BASE_URL}/admin/spare-parts/${id}`,
  },

  // ==========================================
  // 联系信息管理
  // ==========================================
  CONTACT_INFO: `${API_BASE_URL}/admin/contact-info`,

  // ==========================================
  // 访问统计
  // ==========================================
  ANALYTICS: {
    SUMMARY: `${API_BASE_URL}/admin/analytics/summary`,
    VISITS: `${API_BASE_URL}/admin/analytics/visits`,
  },

  // ==========================================
  // 用户管理
  // ==========================================
  USERS: {
    LIST: `${API_BASE_URL}/admin/users`,
    BY_ID: (id) => `${API_BASE_URL}/admin/users/${id}`,
  },

  // ==========================================
  // 联系消息管理
  // ==========================================
  MESSAGES: {
    LIST: `${API_BASE_URL}/admin/contact-messages`,
    BY_ID: (id) => `${API_BASE_URL}/admin/contact-messages/${id}`,
  },

  // ==========================================
  // 订阅管理
  // ==========================================
  SUBSCRIPTIONS: {
    LIST: `${API_BASE_URL}/admin/subscriptions`,
    STATS: `${API_BASE_URL}/admin/subscription-stats`,
    MESSAGES: `${API_BASE_URL}/admin/subscription-messages`,
    UPLOAD_MESSAGE_IMAGE: `${API_BASE_URL}/admin/upload-message-image`,
    SEND_MESSAGE: `${API_BASE_URL}/admin/send-subscription-message`,
    MESSAGE_BY_ID: (id) => `${API_BASE_URL}/admin/subscription-messages/${id}`,
    BY_ID: (id) => `${API_BASE_URL}/admin/subscriptions/${id}`,
  },
};

/**
 * 导出配置
 */
export { API_BASE_URL, FRONTEND_URL, ADMIN_URL };
export default API_BASE_URL;
